import React from "react";

const Contact = () => {
    return (
        <div>
            <h2>Contato</h2>
            <p>Email: contato@meusite.com</p>
        </div>
    );
};

export default Contact;
